import { RunwayModelsResponse } from '@/types';

export const UPDATE_WORKFLOW_RUN_STEP_RUN_GRAPH = 'UPDATE_WORKFLOW_RUN_STEP_RUN_GRAPH';

export interface UpdateWorkflowRunStepRunGraphAction {
    type: typeof UPDATE_WORKFLOW_RUN_STEP_RUN_GRAPH;
    payload: RunwayModelsResponse['workflowRunStepRunGraphs'];
}

export const updateWorkflowRunStepRunGraphs = (
    payload: RunwayModelsResponse['workflowRunStepRunGraphs'],
): UpdateWorkflowRunStepRunGraphAction => {
    return {
        type: UPDATE_WORKFLOW_RUN_STEP_RUN_GRAPH,
        payload: payload,
    };
};
